import React, { useState } from "react";
import styles from "./ForgotPassword.module.css";
import { resetPassword } from "../../services/AuthServices";
import { useTranslation } from "react-i18next";
import { redirect, useLocation } from "react-router-dom";

const ResetPassword = () => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const { t } = useTranslation();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get("token");

  const handleResetPAssword = async (e: React.FormEvent) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      alert("Passwords do not match");
      return;
    }

    console.log("Token:", token);
    if (!token) {
      alert("Token is missing in the URL");
      return;
    }

    const res = await resetPassword(token, password);

    if (!res) {
      alert("Error resetting password");
    }
    alert("Password reset successfully");

    redirect("/login");
  };

  return (
    <div className={styles.mainContainer}>
      <div className={styles.leftPanelContainer}>
        <div>
          <img
            className={styles.logo}
            src="/images/logo/company.svg"
            alt="logo"
          />
          <h1>Oh no</h1>
        </div>
      </div>
      <div className={styles.container}>
        <div className={styles.loginFormContainer}>
          <form onSubmit={handleResetPAssword}>
            <div className={`form-group ${styles.formGroup}`}>
              <label>{t("password")}</label>
              <input
                type="password"
                className={styles.inputBox}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
            <div className={`form-group ${styles.formGroup}`}>
              <label>{t("profile.update.security.confirmPassword")}</label>
              <input
                type="password"
                className={styles.inputBox}
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
              />
            </div>
            <button type="submit" className={styles.button}>
              {t("reset")}
            </button>{" "}
          </form>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
